// views/LandingPage/components/LandingPageUsagesList/usagesList.js
import coworkingImg from "./images/coworking.jpg";
import privateOfficeImg from "./images/privateoffice.jpg";
import meetingRoomImg from "./images/meetingroom.jpg";
import seminarImg from "./images/seminar.jpg";
import conferenceImg from "./images/conference.jpg";
import teamBuildingImg from "./images/teambuilding.jpg";
import sharedOfficeImg from "./images/sharedoffice.jpg";

const usagesList = [
  {
    usageImg: coworkingImg,
    usageKey: "usages.coworking",
    usageMinPrice: "10€",
    usageLink: "/static/location-espace-coworking",
  },
  {
    usageImg: privateOfficeImg,
    usageKey: "usages.privateOffice",
    usageMinPrice: "30€",
    usageLink: "/static/bureau-a-louer",
  },
  {
    usageImg: meetingRoomImg,
    usageKey: "usages.meetingRoom",
    usageMinPrice: "20€",
    usageLink: "/static/salle-de-reunion",
  },
  {
    usageImg: seminarImg,
    usageKey: "usages.seminarRoom",
    usageMinPrice: "20€",
    usageLink: "/static/salle-de-seminaire",
  },
  {
    usageImg: conferenceImg,
    usageKey: "usages.conferenceRoom",
    usageMinPrice: "150€",
    usageLink: "/static/salle-de-conference",
  },
  {
    usageImg: teamBuildingImg,
    usageKey: "usages.teamBuildingSpace",
    usageMinPrice: "20€",
    usageLink: "/static/salle-team-building",
  },
  {
    usageImg: sharedOfficeImg,
    usageKey: "usages.sharedOffice",
    usageMinPrice: "10€",
    usageLink: "/static/bureaux-a-partager",
  },
];

export default usagesList;